export default __webpack_public_path__ + "static/media/modern-logo-on-dark.4e1d684e.svg";